import { Link, useLocation, useNavigate } from "react-router-dom";
import { ASSETS } from "@/lib/brand";
import { scrollToSection } from "@/components/Nav";

export default function Footer() {
  const loc = useLocation();
  const navigate = useNavigate();
  const isHome = loc.pathname === "/";

  const goToSection = (id) => (e) => {
    e.preventDefault();
    if (isHome) scrollToSection(id);
    else navigate("/", { state: { scrollTo: id } });
  };

  return (
    <footer data-testid="footer" className="relative bg-[#0A0A0A] border-t border-white/5 pt-20 pb-10 px-6 md:px-12">
      <div className="mx-auto max-w-[1500px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <img src={ASSETS.logo} alt="Watson Group" className="h-40 md:h-56 w-auto" />
          </div>
          <div className="md:col-span-3 space-y-3 text-sm">
            <div className="overline text-white/40 mb-4">Navigate</div>
            <a href="/#about" onClick={goToSection("about")} className="block text-white/70 hover:text-[#CBBFAE] transition-colors">About</a>
            <a href="/#listings" onClick={goToSection("listings")} className="block text-white/70 hover:text-[#CBBFAE] transition-colors">Archive</a>
            <a href="/#news" onClick={goToSection("news")} className="block text-white/70 hover:text-[#CBBFAE] transition-colors">Journal</a>
            <Link to="/agents" className="block text-white/70 hover:text-[#CBBFAE] transition-colors">Agents</Link>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-4 pt-8 border-t border-white/5 overline text-white/40 text-center">
          <div>© {new Date().getFullYear()} Watson Group Realty · All rights reserved</div>
          <Link to="/admin/login" data-testid="admin-portal-link" className="hover:text-[#CBBFAE]">Portal</Link>
        </div>
      </div>
    </footer>
  );
}
